import { timeRangeValues } from '@/common/components/TimeRangeSelect/constants'
import { metricsDimensionTabs } from '@/metrics/constants'
import { orderByValues } from '@/metrics/hooks/useFilters/constants'
import { transactionTypes } from '@/returns/constants'

import { filters, orderingTitles } from './constants'

const getReasonTagColorsMap = theme => ({
  too_big: {
    background: theme.colors.danger.surface,
    border: theme.colors.danger.default,
    text: theme.colors.danger.onSurface,
  },
  too_small: {
    background: theme.colors.ai.surface,
    border: theme.colors.ai.default,
    text: theme.colors.ai.onSurface,
  },
})

const getFallbackReasonTagColors = theme => ({
  background: theme.colors.disabled.surface,
  border: theme.colors.border.default,
  text: theme.colors.text.muted,
})

const getReasonProgressColorMap = theme => ({
  too_big: theme.colors.danger.surface,
  too_small: theme.colors.ai.default,
})

export const getFilterParams = selectedFilters => {
  return filters.reduce((acc, filter) => {
    if (selectedFilters[filter.name] === undefined) {
      return acc
    }

    if (selectedFilters[filter.name] === 'all') {
      acc[filter.backendName] = null
    } else {
      acc[filter.backendName] = selectedFilters[filter.name]
    }

    return acc
  }, {})
}

export const getTitleByOrdering = (title, ordering, t) => {
  return `${t(title)} ${t(`por ${orderingTitles?.[ordering?.replace('-', '')]}`)}`
}

export const getDateByTimeRange = (date, language, type) => {
  if (date) {
    const formats = {
      [timeRangeValues.lastYear]: { month: 'short', year: '2-digit' },
      [timeRangeValues.lastMonth]: { day: 'numeric' },
      [timeRangeValues.lastWeek]: { weekday: 'short', day: '2-digit', month: 'short' },
    }
    const formatter = new Intl.DateTimeFormat(language, formats[type])

    return formatter.format(new Date(date))
  }
}

export const getReasonLabel = (reason, t) => {
  const reasonLabels = {
    too_small: t('Muy pequeño'),
    too_big: t('Muy grande'),
  }

  return reasonLabels[reason] || reason
}

export const toPercent = value => Math.round(value * 100)

export const getRegionNames = language => new Intl.DisplayNames([language], { type: 'region' })

export const hasRecommendationGlobal = recommendationGlobal =>
  recommendationGlobal && Object.keys(recommendationGlobal).length > 0

export const hasRecommendation = recommendation => recommendation && Object.keys(recommendation).length > 0

export const getReasonTagColors = (reason, theme) =>
  getReasonTagColorsMap(theme)[reason] || getFallbackReasonTagColors(theme)

export const getReasonTextColor = (reason, theme) => getReasonTagColors(reason, theme).text

export const getReasonProgressColor = (reason, theme) =>
  getReasonProgressColorMap(theme)[reason] || theme.colors.border.default

export const getReasonColors = theme => {
  return {
    [transactionTypes.refund]: {
      bar: theme.colors.background.decorative,
      text: theme.colors.text.default,
    },
    [transactionTypes.exchange]: {
      bar: theme.colors.ai.surface,
      text: theme.colors.text.default,
    },
  }
}

export const getMetricsDimensionTabOptions = t => {
  return [
    { id: metricsDimensionTabs.product, label: t('Producto') },
    { id: metricsDimensionTabs.order, label: t('Pedido y solicitud') },
  ]
}

export const getReasonsFilters = (reasonsFilters, showExchanges) => {
  const isOrderingByReturns = reasonsFilters.ordering.replace('-', '') === orderByValues.refundCount

  if (showExchanges || isOrderingByReturns) return reasonsFilters

  return { ordering: `-${orderByValues.refundCount}` }
}
